import React, { useState, useRef } from "react";
import asideMapping from "../../utility/aside";
import DataTable from 'react-data-table-component';
import LoaderIndex from "~/containers/LoaderIndex";
import { ResponsiveBar } from '@nivo/bar';
import { ResponsivePie } from '@nivo/pie';

// import LoaderIndex from "../../containers/LoaderIndex"

const TableFilters = (props) => {

    const refForm = useRef();
    const selectRegion = useRef();
    const selectWard = useRef();    
    const selectDistrict = useRef();

    const [selectedFruit, setSelectedFruit] = useState('orange');
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [selectedWard, setSelectedWard] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedParty, setSelectedParty] = useState(null);

    const graphLegend = props.graphLegend;
    const [regions, setRegions] = useState(graphLegend?.regions ?? [])
    const [wards, setWards] = useState(graphLegend?.wards ?? [])
    const [districts, setDistricts] = useState(graphLegend?.districts ?? [])
    const [parties, setParties] = useState(graphLegend?.parties ?? [])

    const allRegions = graphLegend?.regions ?? [];
    const allWards = graphLegend?.wards ?? [];
    const allDistricts = graphLegend?.districts ?? [];
    const allParties = graphLegend?.parties ?? [];

    const clearHandle = () => {
        setSelectedRegion("disabledOption");
        setSelectedWard("disabledOption");
        setSelectedDistrict("disabledOption");        
    }

    const handleRegions = (code) => {
        const filteredWards = allWards.filter(obj => {
            return obj.region_code === code;
          });
        setWards(filteredWards);
        setSelectedRegion(code);    
        setSelectedWard("disabledOption");
        setSelectedDistrict("disabledOption");
    }

    const handleWards = (code) => {
        setSelectedWard(null);
        const filteredDistricts = allDistricts.filter(obj => {
            return obj.ward_code === code;
          });
        setDistricts(filteredDistricts);
        setSelectedWard(code);
        setSelectedDistrict("disabledOption");
    }

    return (
        <div className="data-table-filters">
                {/* <select>
                    <option selected disabled aria-readonly>Slovensko</option>
                </select> */}
                <select
                    onChange={(e) => handleRegions(e.target.value)}
                    value={selectedRegion}
                >                   
                    <option value="disabledOption" selected disabled aria-readonly>Vyberte kraj</option> 
                    {regions.map((option, index) => {
                    return (                        
                        <option key={index} value={option.code}>
                        {option.name}
                        </option>
                    );
                    })}                    
                </select>

                <select
                    onChange={(e) => handleWards(e.target.value)}
                    disabled={selectedRegion === null || selectedRegion == 'disabledOption'}
                    value={selectedWard}
                >           
                    <option value="disabledOption" selected disabled aria-readonly>Vyberte obvod</option>         
                    {wards.map((option, index) => {
                    return (                        
                        <option key={index} value={option.code}>
                        {option.name}
                        </option>
                    );
                    })}                    
                </select>

                <select
                    onChange={e => setSelectedDistrict(e.target.value)}
                    disabled={selectedWard === null || selectedWard == 'disabledOption'}
                    value={selectedDistrict}
                >                    
                    <option value="disabledOption" selected disabled aria-readonly>Vyberte okres</option>
                    {districts.map((option, index) => {
                    return (                        
                        <option key={index} value={option.code}>
                        {option.name}
                        </option>
                    );
                    })}                    
                </select>

                {/* <button onClick={clearHandle}>RESET</button> */}
                </div>
    )
}

export default TableFilters;